import type { Option } from '../../lib/stories';
import './RadioGroup.css';

type RadioGroupProps = {
  label: string;
  name: string;
  value: string;
  options: Option[];
  onChange: (value: string) => void;
};

export function RadioGroup({ label, name, value, options, onChange }: RadioGroupProps) {
  return (
    <fieldset className="radio-group">
      <legend className="radio-group__legend">{label}</legend>
      <div className="radio-group__options">
        {options.map((opt) => (
          <label
            key={opt.value}
            className={`radio-pill${opt.value === value ? ' radio-pill--selected' : ''}`}
          >
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={opt.value === value}
              onChange={() => onChange(opt.value)}
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
